var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D1E3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2457_26341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 18.5C13.5304 18.5 14.0391 18.7107 14.4142 19.0858C14.7893 19.4609 15 19.9696 15 20.5C15 21.0304 14.7893 21.5391 14.4142 21.9142C14.0391 22.2893 13.5304 22.5 13 22.5C12.4696 22.5 11.9609 22.2893 11.5858 21.9142C11.2107 21.5391 11 21.0304 11 20.5C11 19.9696 11.2107 19.4609 11.5858 19.0858C11.9609 18.7107 12.4696 18.5 13 18.5ZM20 18.5C20.5304 18.5 21.0391 18.7107 21.4142 19.0858C21.7893 19.4609 22 19.9696 22 20.5C22 21.0304 21.7893 21.5391 21.4142 21.9142C21.0391 22.2893 20.5304 22.5 20 22.5C19.4696 22.5 18.9609 22.2893 18.5858 21.9142C18.2107 21.5391 18 21.0304 18 20.5C18 19.9696 18.2107 19.4609 18.5858 19.0858C18.9609 18.7107 19.4696 18.5 20 18.5ZM27 18.5C27.5304 18.5 28.0391 18.7107 28.4142 19.0858C28.7893 19.4609 29 19.9696 29 20.5C29 21.0304 28.7893 21.5391 28.4142 21.9142C28.0391 22.2893 27.5304 22.5 27 22.5C26.4696 22.5 25.9609 22.2893 25.5858 21.9142C25.2107 21.5391 25 21.0304 25 20.5C25 19.9696 25.2107 19.4609 25.5858 19.0858C25.9609 18.7107 26.4696 18.5 27 18.5Z",
    fill: "#505762"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2457_26341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.eae113ab88299d6309e4614078f37e0f.svg";
export { ForwardRef as ReactComponent };